export function getSessionCount(ID) {
  let sessionCount = localStorage.getItem(ID);
  sessionCount = sessionCount ? parseInt(sessionCount, 10) : 0;
  return sessionCount;
}

export function incrementSessionCount(ID) {
  let sessionCount = getSessionCount(ID);
  sessionCount += 1;
  localStorage.setItem(ID, sessionCount);
}
